<template>
    <span
        class="inline-flex items-center rounded-full bg-zinc-100 text-black border border-zinc-200 px-3.5 py-1.5 text-base"
    >
        <slot></slot>
        <button
            v-if="onClose"
            type="button"
            @click="onClose(onCloseParams)"
            class="ml-2 h-4 w-4 rounded-full hover:bg-gray-200"
        >
            <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                />
            </svg>
        </button>
    </span>
</template>

<script>
export default {
    name: 'FormFieldChip',
    props: {
        onClose: {
            type: Function,
            default: null,
        },
        onCloseParams: {
            default: null,
        },
    },
};
</script>
